import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import ReactGA from "react-ga4";

import { selectFavoriteIds } from "../../../routes/Favorite/favorite.ducks";
import { SimilarAdCard } from "../../../components/SimilarAdCard";
import AdList from "../../../components/AdList";
import styles from "./newAdsSection.scss";
import { AdCard } from "../../../components/AdCard";
import { clearNewAds, getNewAds, selectNewAds } from "../../../routes/Ad/ad.ducks";
import { LinkTargetEnum } from "../../../models";

const MAX_ADS_LIMIT = 160;

function NewAdsSection(props: any) {
  const {
    ads,
    isMobile,
    className,
    renderGoogleAds,
    showDetails,
    module,
    favoriteIds,
    location,
    getNewAds,
    clearNewAds,
    category,
    categoryLv1Ids,
    isHomePage
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    loadData();

    return () => {
      clearNewAds();
    };
  }, [
    location,
    module,
    categoryLv1Ids
  ]);

  const buildQueryParams = () => ({
    ...(module && { module }),
    ...(category && { category }),
    ...(categoryLv1Ids && { categoryLv1Ids: categoryLv1Ids })
  });

  const loadData = async () => {
    await getNewAds(
      favoriteIds,
      undefined,
      8,
      module,
      buildQueryParams(),
      1
    );

    setIsLoading(false);
  };

  const loadMore = async () => {
    if (isLoadingMore || !ads || !ads.nextPage) return;

    setIsLoadingMore(true);
    await getNewAds(
      favoriteIds,
      undefined,
      8,
      module,
      buildQueryParams(),
      ads.nextPage
    );
    setIsLoadingMore(false);

    ReactGA.event({
      category: "Naslovnica",
      action: "Click",
      label: "Učitano više novih oglasa"
    });
  };

  // if ads are empty, don't display the section
  if (!ads || (ads && ads.data && !(ads.data.length >= 4))) {
    return null;
  }


  const currentAdsCount = (ads && ads.data && ads.data.length) || 0;
  const hasMoreAds = isHomePage && ads && ads.nextPage && currentAdsCount < MAX_ADS_LIMIT;

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.title}>{"Najnoviji oglasi"}</div>
      {/*
      // @ts-ignore */}
      <AdList
        ads={ads ? ads.data : []}
        adCardProps={{
          hasFavorite: true,
          adLists: { newAds: ads || {} },
          isMobile,
          className: isMobile ? styles.cardMobile : styles.cardDesktop,
          target: LinkTargetEnum.blank
        }}
        renderGoogleAds={renderGoogleAds}
        AdCardComponent={isMobile ? AdCard : SimilarAdCard}
        responsiveProps={{ xs: 24, sm: 12, md: 12, lg: 12, xl: 8, xxl: 6 }}
        gutter={isMobile ? 0 : 20}
        showDetails={showDetails}
        isLoading={isLoading}
      />
      {hasMoreAds && (
        <div className={styles.loadMoreButtonContainer}>
          <Button
            className={styles.loadMoreButton}
            onClick={loadMore}
            loading={isLoadingMore}
          >
            {"Vidi više"}
          </Button>
        </div>
      )}
    </div>
  );
}

NewAdsSection.defaultProps = {
  ads: {},
  favoriteIds: undefined,
  isMobile: false,
  className: "",
  module: null,
  renderGoogleAds: () => null,
  isHomePage: false
};

function mapStateToProps(state) {
  return {
    ads: selectNewAds(state),
    favoriteIds: selectFavoriteIds(state),
    location: state.router.location
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNewAds: (
      favoriteIds,
      _,
      itemPerPage,
      module,
      queryParams,
      page
    ) =>
      dispatch(
        getNewAds({
          favoriteIds,
          itemPerPage,
          module,
          queryParams,
          page
        })
      ),
    clearNewAds: () => dispatch(clearNewAds())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAdsSection);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/NewAdsSection/NewAdsSection.tsx